import { render, staticRenderFns } from "./AuditPendenciesDetail.vue?vue&type=template&id=ed2752ca"
import script from "./AuditPendenciesDetail.vue?vue&type=script&lang=js"
export * from "./AuditPendenciesDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports